import { render, staticRenderFns } from "./CriteriaPage.vue?vue&type=template&id=21486c7e"
import script from "./CriteriaPage.vue?vue&type=script&lang=ts"
export * from "./CriteriaPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports